import './StepOptions.css';
import React, { useEffect } from 'react';
import { withTranslate } from 'react-redux-multilingual';
import Draggable from 'react-draggable';
import ClearIcon from '@mui/icons-material/Clear';
import Divider from '@mui/material/Divider';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import OutlinedInput from '@mui/material/OutlinedInput';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import Autocomplete from '@mui/material/Autocomplete';
import Chip from '@mui/material/Chip';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormGroup from '@mui/material/FormGroup';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormLabel from '@mui/material/FormLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import CircularProgress from '@mui/material/CircularProgress';
import InputAdornment from '@mui/material/InputAdornment';
import CenterFocusStrongIcon from '@mui/icons-material/CenterFocusStrong';

import FomulaFx from '../../../libraries/Icons/formulaFx.png';
import SquareBrackets from '../../../libraries/Icons/squareBrackets.png';
import CurlyBrackets from '../../../libraries/Icons/curlyBrackets.png';
import { InspectSelector } from '../../../services/Workspace.service';

function StepOptions(props) {
    const outputKeyRegex = /^\$[a-zA-Z0-9_]{0,50}$/;
    const { translate, open, anchorPosition, index, scriptsteps, handleClose, handleAgree, handleOpenCalculation, handleOpenArray, handleOpenObject } = props;
    const [isError, setIsError] = React.useState(false);
    const [isExist, setIsExist] = React.useState(false);
    const [step, setStep] = React.useState();
    const [selectorPicker, setSelectorPicker] = React.useState({ open: false, loading: false, data: null, error: "" });

    const handleOnChange = (e) => {
        let newStep = JSON.parse(JSON.stringify(step));
        let name = e.target.name;
        let value = e.target.value;
        newStep.options[name].value = value;
        switch (name) {
            case "actionsForDownload":
                switch (value) {
                    case "click":
                        delete newStep.options.text;
                        break;
                    case "select":
                        newStep.options.text = {
                            required: true,
                            placeholder: 'male',
                            value: ""
                        }
                        break;
                }
                break;
            case "findElementBy":
                switch (value) {
                    case "selector":
                        delete newStep.options.text;
                        newStep.options.selector = {
                            required: true,
                            placeholder: 'div.banner',
                            value: ""
                        }
                        newStep.output.icon = "rule";
                        break;
                    case "text":
                        delete newStep.options.selector;
                        newStep.options.text = {
                            required: true,
                            placeholder: 'Google Search',
                            value: ""
                        }
                        newStep.output.icon = "data_array";
                }
        }
        setStep(newStep);
    }

    const handleOnSwitch = (e) => {
        let newStep = JSON.parse(JSON.stringify(step));
        let name = e.target.name;
        let value = e.target.checked;
        newStep.options[name].value = value;
        setStep(newStep);
    }

    const handleOnChangeOutputKey = (e) => {
        let newStep = JSON.parse(JSON.stringify(step));
        let newValue = e.target.value;
        if(outputKeyRegex.test(newValue) && newValue.includes("$")) {
            newStep.output.key = newValue;
            setStep(newStep);
        }
    }

    const getInspectUrl = () => {
        const openBrowserStep = scriptsteps
            .slice(0, index + 1)
            .reverse()
            .find(item => item?.name === 'openBrowser' && item?.options?.url?.value);
        return openBrowserStep?.options?.url?.value || "";
    }

    const handleOpenSelectorPicker = async () => {
        const url = getInspectUrl();
        setSelectorPicker({ open: true, loading: true, data: null, error: "" });
        if(!url) {
            setSelectorPicker({ open: true, loading: false, data: null, error: "先に Open Browser のURLを設定してください。" });
            return;
        }
        try {
            const res = await InspectSelector(url, scriptsteps, index, step?.name);
            if(res.data?.statusCd !== "SUCCESS") throw new Error(res.data?.output || "ページ解析に失敗しました。");
            setSelectorPicker({ open: true, loading: false, data: res.data, error: "" });
        } catch(error) {
            setSelectorPicker({ open: true, loading: false, data: null, error: error?.response?.data?.output || error?.message || "ページ解析に失敗しました。" });
        }
    }

    const handleSelectElement = (element) => {
        let newStep = JSON.parse(JSON.stringify(step));
        newStep.options.selector.value = element.selector;
        setStep(newStep);
        setSelectorPicker({ open: false, loading: false, data: null, error: "" });
    }

    const handleClickAgree = () => {
        setIsError(false);
        setIsExist(false);
        // Validate options
        let keys = Object.keys(step.options);
        for(let i = 0 ; i < keys.length ; i++) {
            let targetOption = step.options[keys[i]];
            if(targetOption.required && !targetOption.value) {
                setIsError(true);
                return;
            }
        }
        // Validate output key
        if(step?.output?.icon && step?.output?.key) {
            if(step?.output?.key?.length < 2 || !outputKeyRegex.test(step?.output?.key)) {
                setIsError(true);
                return;
            }
            for(let i = 0 ; i < scriptsteps.length ; i++) {
                if(
                    (i !== index) && 
                    (scriptsteps[i]?.output?.key === step?.output?.key) &&
                    (scriptsteps[i]?.name !== 'endloop' && scriptsteps[i]?.name !== 'endforeach')
                ) {
                    setIsExist(true);
                    return;
                }
            }
        }
        // Callback
        handleAgree(JSON.parse(JSON.stringify(step)), index);
    }

    const IsFx = (value) => {
        return /^fx\(.*?\)/.test(value.replace(/\r\n|\r|\n/g,""));
    }

    useEffect(() => {
        if(index === -Infinity) {
            handleClose();
        } else {
            setStep(JSON.parse(JSON.stringify(scriptsteps[index] || {})));
            setIsError(false);
            setIsExist(false);
        }
    }, [index, scriptsteps])

   return (
        <Draggable 
            handle=".handle"
            defaultPosition={{x: 0, y: 0}}
            positionOffset={anchorPosition}
        >
            {<Box className='step-options-box' sx={{ display: (!open ? 'none' : '') }}>
                <Box className='handle step-options-top'>
                    <Box sx={{ display: "flex", ml: 1 }}>
                        <span className="material-symbols-outlined chip-icon">{step?.icon}</span>
                    </Box>
                    <Box className='header'>
                        <Typography variant='span' className='title'>{step?.title}</Typography>
                    </Box>
                    <Box sx={{ display: "flex", justifyContent: "right" }}>
                        <Tooltip title={translate('close')}>
                            <IconButton size="small" color='secondary' onClick={handleClose}>
                                <ClearIcon fontSize="inherit" />
                            </IconButton>
                        </Tooltip>
                    </Box>
                </Box>
                <Divider />
                <Box sx={{ display: "grid", gap: 1, p: 2, maxHeight: "50vh", overflow: "auto" }}>
                    {/* outputkey */}
                    {step?.output?.icon && step?.output?.key && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('outputkey')}<span>*</span></Typography>
                        <OutlinedInput
                            type='search'
                            name="url"
                            size='small' 
                            placeholder={step?.output?.placeholder}
                            value={step?.output?.key}
                            error={((step?.output?.key?.length < 2) && isError) || isExist}onChange={handleOnChangeOutputKey}
                        />
                        {(step?.output?.key?.length < 2) && isError &&
                        <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>}
                        {isExist &&
                        <FormHelperText sx={{ color: "error.main" }}>{translate('thekeynameisalreadyinuse')}</FormHelperText>}
                    </FormControl>}
                    {/* providerID */}
                    {step?.options?.providerID && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('providerid')}{step?.options?.providerID?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="providerID"
                            size='small'
                            placeholder={step?.options?.providerID?.placeholder}
                            value={step?.options?.providerID?.value}
                            error={!step?.options?.providerID?.value && step?.options?.providerID?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "providerID", step?.options?.providerID?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.providerID?.value && step?.options?.providerID?.required && isError &&
                            <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* spreadsheetID */}
                    {step?.options?.spreadsheetID && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('spreadsheetid')}{step?.options?.spreadsheetID?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="spreadsheetID"
                            size='small' 
                            placeholder={step?.options?.spreadsheetID?.placeholder}
                            value={step?.options?.spreadsheetID?.value}
                            error={!step?.options?.spreadsheetID?.value && step?.options?.spreadsheetID?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "spreadsheetID", step?.options?.spreadsheetID?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.spreadsheetID?.value && step?.options?.spreadsheetID?.required && isError &&
                            <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* directory */}
                    {step?.options?.directory && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('directory')}{step?.options?.directory?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="directory"
                            size='small' 
                            placeholder={step?.options?.directory?.placeholder}
                            value={step?.options?.directory?.value}
                            error={!step?.options?.directory?.value && step?.options?.directory?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "directory", step?.options?.directory?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.directory?.value && step?.options?.directory?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* layout */}
                    {step?.options?.layout && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('layout')}{step?.options?.layout?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="layout"
                            size='small' 
                            placeholder={step?.options?.layout?.placeholder}
                            value={step?.options?.layout?.value}
                            error={!step?.options?.layout?.value && step?.options?.layout?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "layout", step?.options?.layout?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.layout?.value && step?.options?.layout?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* parameters */}
                    {step?.options?.parameters && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('parameters')}{step?.options?.parameters?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="parameters"
                            size='small' 
                            placeholder={step?.options?.parameters?.placeholder}
                            value={step?.options?.parameters?.value}
                            error={!step?.options?.parameters?.value && step?.options?.parameters?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "parameters", step?.options?.parameters?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.parameters?.value && step?.options?.parameters?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* recordID */}
                    {step?.options?.recordID && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('recordid')}{step?.options?.recordID?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="recordID"
                            size='small' 
                            placeholder={step?.options?.recordID?.placeholder}
                            value={step?.options?.recordID?.value}
                            error={!step?.options?.recordID?.value && step?.options?.recordID?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "recordID", step?.options?.recordID?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.recordID?.value && step?.options?.recordID?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* fieldData */}
                    {step?.options?.fieldData && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('fielddata')}{step?.options?.fieldData?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="fieldData"
                            size='small' 
                            placeholder={step?.options?.fieldData?.placeholder}
                            value={step?.options?.fieldData?.value}
                            error={!step?.options?.fieldData?.value && step?.options?.fieldData?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "fieldData", step?.options?.fieldData?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.fieldData?.value && step?.options?.fieldData?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* scriptName */}
                    {step?.options?.scriptName && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('scriptname')}{step?.options?.scriptName?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="scriptName"
                            size='small' 
                            placeholder={step?.options?.scriptName?.placeholder}
                            value={step?.options?.scriptName?.value}
                            error={!step?.options?.scriptName?.value && step?.options?.scriptName?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "scriptName", step?.options?.scriptName?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.scriptName?.value && step?.options?.scriptName?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* containerFieldname */}
                    {step?.options?.containerFieldname && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('containerfieldname')}{step?.options?.containerFieldname?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="containerFieldname"
                            size='small' 
                            placeholder={step?.options?.containerFieldname?.placeholder}
                            value={step?.options?.containerFieldname?.value}
                            error={!step?.options?.containerFieldname?.value && step?.options?.containerFieldname?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "containerFieldname", step?.options?.containerFieldname?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.containerFieldname?.value && step?.options?.containerFieldname?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* globalFields */}
                    {step?.options?.globalFields && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('globalfields')}{step?.options?.globalFields?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="globalFields"
                            size='small' 
                            placeholder={step?.options?.globalFields?.placeholder}
                            value={step?.options?.globalFields?.value}
                            error={!step?.options?.globalFields?.value && step?.options?.globalFields?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "globalFields", step?.options?.globalFields?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.globalFields?.value && step?.options?.globalFields?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* browser */}
                    {step?.options?.browser && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('browser')}{step?.options?.browser?.required && <span>*</span>}</Typography>
                        <Autocomplete
                            name="browser"
                            size='small'
                            multiple={step?.options?.browser?.value ? true : false}
                            options={scriptsteps?.filter(item => item.name === 'openBrowser')?.map(item => item.output.key)}
                            getOptionLabel={(option) => option || ""}
                            isOptionEqualToValue={(option, value) => option && value && option === value}
                            value={step?.options?.browser?.value ? [step?.options?.browser?.value] : null}onChange={(event, newValue) => {
                                handleOnChange({ target : { name: 'browser', value: (typeof newValue === "object") ? newValue[0] : newValue } });
                            }}
                            renderTags={() => 
                                <Box className='browser' size='small' variant="filled" label={step?.options?.browser?.value} component={Chip}></Box>
                            }
                            renderInput={(params) => (
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                    <TextField
                                        {...params}
                                        error={!step?.options?.browser?.value && step?.options?.browser?.required && isError}
                                        placeholder={step?.options?.browser?.placeholder}
                                        sx={{
                                            "& .MuiAutocomplete-endAdornment": {
                                                paddingRight: "40px"
                                            }
                                        }}
                                    />
                                    <IconButton sx={{ position: "absolute", right: "15px" }} size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "browser", step?.options?.browser?.value)}><img src={FomulaFx} width={22}/></IconButton>
                                </Box>
                            )}
                        />
                        {!step?.options?.browser?.value && step?.options?.browser?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* url */}
                    {step?.options?.url && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('url')}{step?.options?.url?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="url"
                            size='small' 
                            placeholder={step?.options?.url?.placeholder}
                            value={step?.options?.url?.value}
                            error={!step?.options?.url?.value && step?.options?.url?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "url", step?.options?.url?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.url?.value && step?.options?.url?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* windowSize */}
                    {/* language */}
                    <Box sx={{ display: "flex", gap: 1 }}>
                        {step?.options?.windowSize && 
                        <FormControl fullWidth size="small" error={!step?.options?.windowSize?.value && step?.options?.windowSize?.required && isError}>
                            <Typography fontSize="inherit" component="label">{translate('windowsize')}{step?.options?.windowSize?.required && <span>*</span>}</Typography>
                            <Select
                                name="windowSize"
                                value={step?.options?.windowSize?.value}
                                onChange={handleOnChange}
                            >
                                <MenuItem value="800,600">800 x 600</MenuItem>
                                <MenuItem value="1024,768">1024 x 768</MenuItem>
                                <MenuItem value="1280,1024">1280 x 1024</MenuItem>
                                <MenuItem value="1330,1330">1330 x 1330</MenuItem>
                                <MenuItem value="1440,1440">1440 x 1440</MenuItem>
                                <MenuItem value="1600,1000">1600 x 1000</MenuItem>
                                <MenuItem value="1920,1080">1920 x 1080</MenuItem>
                                <MenuItem value="1920,1200">1920 x 1200</MenuItem>
                            </Select>
                            {!step?.options?.windowSize?.value && step?.options?.windowSize?.required && isError &&
                            <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                            }
                        </FormControl>}
                        {step?.options?.language && 
                        <FormControl fullWidth size="small" error={!step?.options?.language?.value && step?.options?.language?.required && isError}>
                            <Typography fontSize="inherit" component="label">{translate('language')}{step?.options?.language?.required && <span>*</span>}</Typography>
                            <Select
                                name="language"
                                value={step?.options?.language?.value}
                                onChange={handleOnChange}
                            >
                                <MenuItem value="en">English</MenuItem>
                                <MenuItem value="vie">Tiếng Việt</MenuItem>
                                <MenuItem value="jpn">日本語</MenuItem>
                            </Select>
                            {!step?.options?.language?.value && step?.options?.language?.required && isError &&
                            <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                            }
                        </FormControl>}
                    </Box>
                    {/* basicAuthUsername */}
                    {/* basicAuthPassword */}
                    {step?.options?.basicAuthUsername && step?.options?.basicAuthPassword &&
                    <Box sx={{ display: "flex", gap: 1 }}>
                        <FormControl>
                            <Typography fontSize="inherit" component="label">{translate('basicauthusername')}{step?.options?.basicAuthUsername?.required && <span>*</span>}</Typography>
                            <OutlinedInput
                            type='search'
                                name="basicAuthUsername"
                                size='small' 
                                placeholder={step?.options?.basicAuthUsername?.placeholder}
                                value={step?.options?.basicAuthUsername?.value}
                                error={!step?.options?.basicAuthUsername?.value && step?.options?.basicAuthUsername?.required && isError}
                                endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "basicAuthUsername", step?.options?.basicAuthUsername?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                                
                                onChange={handleOnChange}
                            />
                            {!step?.options?.basicAuthUsername?.value && step?.options?.basicAuthUsername?.required && isError &&
                            <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                            }
                        </FormControl>
                        <FormControl>
                            <Typography fontSize="inherit" component="label">{translate('basicauthpassword')}{step?.options?.basicAuthUsername?.required && <span>*</span>}</Typography>
                            <OutlinedInput
                            type='search'
                                name="basicAuthPassword"
                                size='small'
                                type='password'
                                placeholder={step?.options?.basicAuthPassword?.placeholder}
                                value={step?.options?.basicAuthPassword?.value}
                                error={!step?.options?.basicAuthPassword?.value && step?.options?.basicAuthPassword?.required && isError}
                                endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "basicAuthPassword", step?.options?.basicAuthPassword?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                                
                                onChange={handleOnChange}
                            />
                            {!step?.options?.basicAuthPassword?.value && step?.options?.basicAuthPassword?.required && isError &&
                            <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                            }
                        </FormControl>
                    </Box>}
                    {/* actionsForDownload */}
                    {step?.options?.actionsForDownload &&  
                    <FormGroup sx={{ ml: 1 }}>
                           <FormLabel>{translate('actionsfordownload')}</FormLabel>
                           <RadioGroup
                                row
                                name="actionsForDownload"
                                value={step?.options?.actionsForDownload?.value}
                                onChange={handleOnChange}
                            >
                                <FormControlLabel value="click" control={<Radio />} label={translate('click')} />
                                <FormControlLabel value="select" control={<Radio />} label={translate('selectoption')} />
                            </RadioGroup>
                    </FormGroup>}
                    {/* findElementBy */}
                    {step?.options?.findElementBy &&  
                    <FormGroup sx={{ ml: 1 }}>
                           <FormLabel>{translate('findelementby')}</FormLabel>
                           <RadioGroup
                                row
                                name="findElementBy"
                                value={step?.options?.findElementBy?.value}
                                onChange={handleOnChange}
                            >
                                <FormControlLabel value="text" control={<Radio />} label={translate('text')} />
                                <FormControlLabel value="selector" control={<Radio />} label={translate('selector')} />
                            </RadioGroup>
                    </FormGroup>}
                    {/* selector */}
                    {step?.options?.selector && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('selector')}{step?.options?.selector?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="selector"
                            size='small' 
                            placeholder={step?.options?.selector?.placeholder}
                            value={step?.options?.selector?.value}
                            error={!step?.options?.selector?.value && step?.options?.selector?.required && isError}
                            endAdornment={
                                <InputAdornment position="end">
                                    <Tooltip title="画面から対象を選択">
                                        <IconButton size='small' color='primary' onClick={handleOpenSelectorPicker}>
                                            <CenterFocusStrongIcon fontSize="small" />
                                        </IconButton>
                                    </Tooltip>
                                    <IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "selector", step?.options?.selector?.value)}><img src={FomulaFx} width={22}/></IconButton>
                                </InputAdornment>
                            }
                            onChange={handleOnChange}
                        />
                        {!step?.options?.selector?.value && step?.options?.selector?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                     {/* targetSelector */}
                     {step?.options?.targetSelector && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('targetselector')}{step?.options?.selector?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="targetSelector"
                            size='small' 
                            placeholder={step?.options?.targetSelector?.placeholder}
                            value={step?.options?.targetSelector?.value}
                            error={!step?.options?.targetSelector?.value && step?.options?.targetSelector?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "targetSelector", step?.options?.targetSelector?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.targetSelector?.value && step?.options?.targetSelector?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                     {/* destinationSelector */}
                     {step?.options?.destinationSelector && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('destinationselector')}{step?.options?.selector?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="destinationSelector"
                            size='small' 
                            placeholder={step?.options?.destinationSelector?.placeholder}
                            value={step?.options?.destinationSelector?.value}
                            error={!step?.options?.destinationSelector?.value && step?.options?.destinationSelector?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "destinationSelector", step?.options?.destinationSelector?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.destinationSelector?.value && step?.options?.destinationSelector?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* document */}
                    {step?.options?.document && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('document')}{step?.options?.document?.required && <span>*</span>}</Typography>
                        <Autocomplete
                            name="document"
                            size='small'
                            multiple={step?.options?.document?.value ? true : false}
                            options={scriptsteps?.filter(item => item.name === 'getDocs')?.map(item => item.output.key)}
                            getOptionLabel={(option) => option || ""}
                            isOptionEqualToValue={(option, value) => option && value && option === value}
                            value={step?.options?.document?.value ? [step?.options?.document?.value] : null}onChange={(event, newValue) => {
                                handleOnChange({ target : { name: 'document', value: (typeof newValue === "object") ? newValue[0] : newValue } });
                            }}
                            renderTags={() => 
                                <Box className='docs' size='small' variant="filled" label={step?.options?.document?.value} component={Chip}></Box>
                            }
                            renderInput={(params) => (
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                    <TextField
                                        {...params}
                                        error={!step?.options?.document?.value && step?.options?.document?.required && isError}
                                        placeholder={step?.options?.document?.placeholder}
                                        sx={{
                                            "& .MuiAutocomplete-endAdornment": {
                                                paddingRight: "40px"
                                            }
                                        }}
                                    />
                                    <IconButton sx={{ position: "absolute", right: "15px" }} size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "document", step?.options?.document?.value)}><img src={FomulaFx} width={22}/></IconButton>
                                </Box>
                            )}
                        />
                        {!step?.options?.document?.value && step?.options?.document?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* text */}
                    {step?.options?.text && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('text')}{step?.options?.text?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="text"
                            size='small' 
                            placeholder={step?.options?.text?.placeholder}
                            value={step?.options?.text?.value}
                            error={!step?.options?.text?.value && step?.options?.text?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "text", step?.options?.text?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.text?.value && step?.options?.text?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* passwords */}
                    {step?.options?.passwords && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('passwords')}{step?.options?.passwords?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="passwords"
                            size='small'
                            type='password'
                            placeholder={step?.options?.passwords?.placeholder}
                            value={step?.options?.passwords?.value}
                            error={!step?.options?.passwords?.value && step?.options?.passwords?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "passwords", step?.options?.passwords?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.passwords?.value && step?.options?.passwords?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* filePath */}
                    {step?.options?.filePath && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('filepath')}{step?.options?.filePath?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="filePath"
                            size='small' 
                            placeholder={step?.options?.filePath?.placeholder}
                            value={step?.options?.filePath?.value}
                            error={!step?.options?.filePath?.value && step?.options?.filePath?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "filePath", step?.options?.filePath?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.filePath?.value && step?.options?.filePath?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* workSheet */}
                    {step?.options?.workSheet && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('worksheet')}{step?.options?.browser?.required && <span>*</span>}</Typography>
                        <Autocomplete
                            name="workSheet"
                            size='small'
                            multiple={step?.options?.workSheet?.value ? true : false}
                            options={scriptsteps?.filter(item => item.name === 'selectSheet')?.map(item => item.output.key)}
                            getOptionLabel={(option) => option || ""}
                            isOptionEqualToValue={(option, value) => option && value && option === value}
                            value={step?.options?.workSheet?.value ? [step?.options?.workSheet?.value] : null}onChange={(event, newValue) => {
                                handleOnChange({ target : { name: 'workSheet', value: (typeof newValue === "object") ? newValue[0] : newValue } });
                            }}
                            renderTags={() => 
                                <Box className='excel' size='small' variant="filled" label={step?.options?.workSheet?.value} component={Chip}></Box>
                            }
                            renderInput={(params) => (
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                    <TextField
                                        {...params}
                                        error={!step?.options?.workSheet?.value && step?.options?.workSheet?.required && isError}
                                        placeholder={step?.options?.workSheet?.placeholder}
                                        sx={{
                                            "& .MuiAutocomplete-endAdornment": {
                                                paddingRight: "40px"
                                            }
                                        }}
                                    />
                                    <IconButton sx={{ position: "absolute", right: "15px" }} size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "workSheet", step?.options?.workSheet?.value)}><img src={FomulaFx} width={22}/></IconButton>
                                </Box>
                            )}
                        />
                        {!step?.options?.workSheet?.value && step?.options?.workSheet?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* spreadsheet */}
                    {step?.options?.spreadsheet && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('spreadsheet')}{step?.options?.browser?.required && <span>*</span>}</Typography>
                        <Autocomplete
                            name="spreadsheet"
                            size='small'
                            multiple={step?.options?.spreadsheet?.value ? true : false}
                            options={scriptsteps?.filter(item => item.name === 'getSpreadsheet')?.map(item => item.output.key)}
                            getOptionLabel={(option) => option || ""}
                            isOptionEqualToValue={(option, value) => option && value && option === value}
                            value={step?.options?.spreadsheet?.value ? [step?.options?.spreadsheet?.value] : null}onChange={(event, newValue) => {
                                handleOnChange({ target : { name: 'spreadsheet', value: (typeof newValue === "object") ? newValue[0] : newValue } });
                            }}
                            renderTags={() => 
                                <Box className='spreadsheet' size='small' variant="filled" label={step?.options?.spreadsheet?.value} component={Chip}></Box>
                            }
                            renderInput={(params) => (
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                    <TextField
                                        {...params}
                                        error={!step?.options?.spreadsheet?.value && step?.options?.spreadsheet?.required && isError}
                                        placeholder={step?.options?.spreadsheet?.placeholder}
                                        sx={{
                                            "& .MuiAutocomplete-endAdornment": {
                                                paddingRight: "40px"
                                            }
                                        }}
                                    />
                                    <IconButton sx={{ position: "absolute", right: "15px" }} size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "spreadsheet", step?.options?.spreadsheet?.value)}><img src={FomulaFx} width={22}/></IconButton>
                                </Box>
                            )}
                        />
                        {!step?.options?.spreadsheet?.value && step?.options?.spreadsheet?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* bucketName */}
                    {step?.options?.bucketName && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('bucketname')}{step?.options?.bucketName?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="bucketName"
                            size='small' 
                            placeholder={step?.options?.bucketName?.placeholder}
                            value={step?.options?.bucketName?.value}
                            error={!step?.options?.bucketName?.value && step?.options?.bucketName?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "bucketName", step?.options?.bucketName?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.bucketName?.value && step?.options?.bucketName?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* fileName */}
                    {step?.options?.fileName && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('filename')}{step?.options?.fileName?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="fileName"
                            size='small' 
                            placeholder={step?.options?.fileName?.placeholder}
                            value={step?.options?.fileName?.value}
                            error={!step?.options?.fileName?.value && step?.options?.fileName?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "fileName", step?.options?.fileName?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.fileName?.value && step?.options?.fileName?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* sheetName */}
                    {step?.options?.sheetName && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('sheetname')}{step?.options?.sheetName?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="sheetName"
                            size='small' 
                            placeholder={step?.options?.sheetName?.placeholder}
                            value={step?.options?.sheetName?.value}
                            error={!step?.options?.sheetName?.value && step?.options?.sheetName?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "sheetName", step?.options?.sheetName?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.sheetName?.value && step?.options?.sheetName?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* spreadsheetDestination */}
                    {step?.options?.spreadsheetDestination && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('spreadsheetdestination')}{step?.options?.browser?.required && <span>*</span>}</Typography>
                        <Autocomplete
                            name="spreadsheetDestination"
                            size='small'
                            multiple={step?.options?.spreadsheetDestination?.value ? true : false}
                            options={scriptsteps?.filter(item => item.name === 'getSpreadsheet')?.map(item => item.output.key)}
                            getOptionLabel={(option) => option || ""}
                            isOptionEqualToValue={(option, value) => option && value && option === value}
                            value={step?.options?.spreadsheetDestination?.value ? [step?.options?.spreadsheetDestination?.value] : null}onChange={(event, newValue) => {
                                handleOnChange({ target : { name: 'spreadsheetDestination', value: (typeof newValue === "object") ? newValue[0] : newValue } });
                            }}
                            renderTags={() => 
                                <Box className='spreadsheet' size='small' variant="filled" label={step?.options?.spreadsheetDestination?.value} component={Chip}></Box>
                            }
                            renderInput={(params) => (
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                    <TextField
                                        {...params}
                                        error={!step?.options?.spreadsheetDestination?.value && step?.options?.spreadsheetDestination?.required && isError}
                                        placeholder={step?.options?.spreadsheetDestination?.placeholder}
                                        sx={{
                                            "& .MuiAutocomplete-endAdornment": {
                                                paddingRight: "40px"
                                            }
                                        }}
                                    />
                                    <IconButton sx={{ position: "absolute", right: "15px" }} size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "spreadsheetDestination", step?.options?.spreadsheetDestination?.value)}><img src={FomulaFx} width={22}/></IconButton>
                                </Box>
                            )}
                        />
                        {!step?.options?.spreadsheetDestination?.value && step?.options?.spreadsheetDestination?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* sheetNameDestination */}
                    {step?.options?.sheetNameDestination && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('sheetnamedestination')}{step?.options?.sheetNameDestination?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="sheetNameDestination"
                            size='small' 
                            placeholder={step?.options?.sheetNameDestination?.placeholder}
                            value={step?.options?.sheetNameDestination?.value}
                            error={!step?.options?.sheetNameDestination?.value && step?.options?.sheetNameDestination?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "sheetNameDestination", step?.options?.sheetNameDestination?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.sheetNameDestination?.value && step?.options?.sheetNameDestination?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* newSheetName */}
                    {step?.options?.newSheetName && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('newsheetname')}{step?.options?.newSheetName?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="newSheetName"
                            size='small' 
                            placeholder={step?.options?.newSheetName?.placeholder}
                            value={step?.options?.newSheetName?.value}
                            error={!step?.options?.newSheetName?.value && step?.options?.newSheetName?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "newSheetName", step?.options?.newSheetName?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.newSheetName?.value && step?.options?.newSheetName?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* cellLabel */}
                    {step?.options?.cellLabel && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('celllabel')}{step?.options?.cellLabel?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="cellLabel"
                            size='small' 
                            placeholder={step?.options?.cellLabel?.placeholder}
                            value={step?.options?.cellLabel?.value}
                            error={!step?.options?.cellLabel?.value && step?.options?.cellLabel?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "cellLabel", step?.options?.cellLabel?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.cellLabel?.value && step?.options?.cellLabel?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                     {/* range */}
                     {step?.options?.range && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('range')}{step?.options?.range?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="range"
                            size='small' 
                            placeholder={step?.options?.range?.placeholder}
                            value={step?.options?.range?.value}
                            error={!step?.options?.range?.value && step?.options?.range?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "range", step?.options?.range?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.range?.value && step?.options?.range?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* regexp */}
                    {step?.options?.regexp && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('regexp')}{step?.options?.regexp?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="regexp"
                            size='small' 
                            placeholder={step?.options?.regexp?.placeholder}
                            value={step?.options?.regexp?.value}
                            error={!step?.options?.regexp?.value && step?.options?.regexp?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "regexp", step?.options?.regexp?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.regexp?.value && step?.options?.regexp?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* find */}
                    {step?.options?.find && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('find')}{step?.options?.find?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="find"
                            size='small' 
                            placeholder={step?.options?.find?.placeholder}
                            value={step?.options?.find?.value}
                            error={!step?.options?.find?.value && step?.options?.find?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "find", step?.options?.find?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.find?.value && step?.options?.find?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* replaceWith */}
                    {step?.options?.replaceWith && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('replacewith')}{step?.options?.replaceWith?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="replaceWith"
                            size='small' 
                            placeholder={step?.options?.replaceWith?.placeholder}
                            value={step?.options?.replaceWith?.value}
                            error={!step?.options?.replaceWith?.value && step?.options?.replaceWith?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "replaceWith", step?.options?.replaceWith?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.replaceWith?.value && step?.options?.replaceWith?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* splitWith */}
                    {step?.options?.splitWith && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('splitwith')}{step?.options?.splitWith?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="splitWith"
                            size='small' 
                            placeholder={step?.options?.splitWith?.placeholder}
                            value={step?.options?.splitWith?.value}
                            error={!step?.options?.splitWith?.value && step?.options?.splitWith?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "splitWith", step?.options?.splitWith?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.splitWith?.value && step?.options?.splitWith?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* destinationDirectory */}
                    {step?.options?.destinationDirectory && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('destinationdirectory')}{step?.options?.destinationDirectory?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="destinationDirectory"
                            size='small' 
                            placeholder={step?.options?.destinationDirectory?.placeholder}
                            value={step?.options?.destinationDirectory?.value}
                            error={!step?.options?.destinationDirectory?.value && step?.options?.destinationDirectory?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "destinationDirectory", step?.options?.destinationDirectory?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.destinationDirectory?.value && step?.options?.destinationDirectory?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* keyboards 
                    https://github.com/puppeteer/puppeteer/blob/v7.1.0/src/common/USKeyboardLayout.ts */}
                    {step?.options?.keyboards && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('keyboards')}{step?.options?.keyboards?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="keyboards"
                            size='small' 
                            placeholder={step?.options?.keyboards?.placeholder}
                            value={step?.options?.keyboards?.value}
                            error={!step?.options?.keyboards?.value && step?.options?.keyboards?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "keyboards", step?.options?.keyboards?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.keyboards?.value && step?.options?.keyboards?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* condition */}
                    {step?.options?.condition && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('condition')}{step?.options?.condition?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="condition"
                            size='small' 
                            placeholder={step?.options?.condition?.placeholder}
                            value={step?.options?.condition?.value}
                            error={!step?.options?.condition?.value && step?.options?.condition?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "condition", step?.options?.condition?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.condition?.value && step?.options?.condition?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* coordinateX */}
                    {step?.options?.coordinateX && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('coordinatex')}{step?.options?.coordinateX?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="coordinateX"
                            size='small' 
                            placeholder={step?.options?.coordinateX?.placeholder}
                            value={step?.options?.coordinateX?.value}
                            error={!step?.options?.coordinateX?.value && step?.options?.coordinateX?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "coordinateX", step?.options?.coordinateX?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.coordinateX?.value && step?.options?.coordinateX?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* coordinateY */}
                    {step?.options?.coordinateY && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('coordinatey')}{step?.options?.coordinateY?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="coordinateY"
                            size='small' 
                            placeholder={step?.options?.coordinateY?.placeholder}
                            value={step?.options?.coordinateY?.value}
                            error={!step?.options?.coordinateY?.value && step?.options?.coordinateY?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "coordinateY", step?.options?.coordinateY?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.coordinateY?.value && step?.options?.coordinateY?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* format */}
                    {step?.options?.format && 
                    <FormControl  size="small" error={!step?.options?.format?.value && step?.options?.format?.required && isError}>
                        <Typography fontSize="inherit" component="label">{translate('format')}{step?.options?.format?.required && <span>*</span>}</Typography>
                        <Select
                            name="format"
                            value={step?.options?.format?.value}onChange={handleOnChange}
                        >
                            <MenuItem value="A5">A5</MenuItem>
                            <MenuItem value="A4">A4</MenuItem>
                            <MenuItem value="A3">A3</MenuItem>
                        </Select>
                        {!step?.options?.format?.value && step?.options?.format?.required && isError &&
                        <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* scale */}
                    {step?.options?.scale && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('scale')}{step?.options?.scale?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="scale"
                            size='small' 
                            placeholder={step?.options?.scale?.placeholder}
                            value={step?.options?.scale?.value}
                            error={!step?.options?.scale?.value && step?.options?.scale?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "scale", step?.options?.scale?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.scale?.value && step?.options?.scale?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* pageRanges */}
                    {step?.options?.pageRanges && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('pageranges')}{step?.options?.pageRanges?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="pageRanges"
                            size='small' 
                            placeholder={step?.options?.pageRanges?.placeholder}
                            value={step?.options?.pageRanges?.value}
                            error={!step?.options?.pageRanges?.value && step?.options?.pageRanges?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "pageRanges", step?.options?.pageRanges?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.pageRanges?.value && step?.options?.pageRanges?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* timeout */}
                    {step?.options?.timeout && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('timeout')}{step?.options?.timeout?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="timeout"
                            size='small' 
                            placeholder={step?.options?.timeout?.placeholder}
                            value={step?.options?.timeout?.value}
                            error={!step?.options?.timeout?.value && step?.options?.timeout?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "timeout", step?.options?.timeout?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.timeout?.value && step?.options?.timeout?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* attribute */}
                    {step?.options?.attribute && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('attribute')}{step?.options?.attribute?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="attribute"
                            size='small' 
                            placeholder={step?.options?.attribute?.placeholder}
                            value={step?.options?.attribute?.value}
                            error={!step?.options?.attribute?.value && step?.options?.attribute?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "attribute", step?.options?.attribute?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.attribute?.value && step?.options?.attribute?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* tab */}
                    {step?.options?.tab && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('tab')}{step?.options?.tab?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="tab"
                            size='small' 
                            placeholder={step?.options?.tab?.placeholder}
                            value={step?.options?.tab?.value}
                            error={!step?.options?.tab?.value && step?.options?.tab?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "tab", step?.options?.tab?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.tab?.value && step?.options?.tab?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* value */}
                    {step?.options?.value && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('value')}{step?.options?.value?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="value"
                            size='small' 
                            placeholder={step?.options?.value?.placeholder}
                            value={step?.options?.value?.value}
                            error={!step?.options?.value?.value && step?.options?.value?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "value", step?.options?.value?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.value?.value && step?.options?.value?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                     {/* code */}
                     {step?.options?.code && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('code')}{step?.options?.code?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="code"
                            size='small'
                            multiline
                            rows={4}
                            placeholder={step?.options?.code?.placeholder}
                            value={step?.options?.code?.value}
                            error={!step?.options?.code?.value && step?.options?.code?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "code", step?.options?.code?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.code?.value && step?.options?.code?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* iterable */}
                    {step?.options?.iterable && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('iterable')}{step?.options?.iterable?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="iterable"
                            size='small' 
                            placeholder={step?.options?.iterable?.placeholder}
                            value={step?.options?.iterable?.value}
                            error={!step?.options?.iterable?.value && step?.options?.iterable?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "iterable", step?.options?.iterable?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.iterable?.value && step?.options?.iterable?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* times */}
                    {step?.options?.times && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('times')}{step?.options?.times?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="times"
                            size='small' 
                            placeholder={step?.options?.times?.placeholder}
                            value={step?.options?.times?.value}
                            error={!step?.options?.times?.value && step?.options?.times?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "times", step?.options?.times?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.times?.value && step?.options?.times?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* array */}
                    {step?.options?.array && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('array')}{step?.options?.array?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="array"
                            size='small' 
                            placeholder={step?.options?.array?.placeholder}
                            value={step?.options?.array?.value}
                            error={!step?.options?.array?.value && step?.options?.array?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenArray(index, step, "array", step?.options?.array?.value)}><img src={SquareBrackets} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.array?.value && step?.options?.array?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* arrayData */}
                    {step?.options?.arrayData && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('arraydata')}{step?.options?.arrayData?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="arrayData"
                            size='small' 
                            placeholder={step?.options?.arrayData?.placeholder}
                            value={step?.options?.arrayData?.value}
                            error={!step?.options?.arrayData?.value && step?.options?.arrayData?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "arrayData", step?.options?.arrayData?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.arrayData?.value && step?.options?.arrayData?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* arrayIndex */}
                    {step?.options?.arrayIndex && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('arrayindex')}{step?.options?.arrayIndex?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="arrayIndex"
                            size='small' 
                            placeholder={step?.options?.arrayIndex?.placeholder}
                            value={step?.options?.arrayIndex?.value}
                            error={!step?.options?.arrayIndex?.value && step?.options?.arrayIndex?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "arrayIndex", step?.options?.arrayIndex?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.arrayIndex?.value && step?.options?.arrayIndex?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* object */}
                    {step?.options?.object && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('object')}{step?.options?.object?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="object"
                            size='small' 
                            placeholder={step?.options?.object?.placeholder}
                            value={step?.options?.object?.value}
                            error={!step?.options?.object?.value && step?.options?.object?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenObject(index, step, "object", step?.options?.object?.value)}><img src={CurlyBrackets} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.object?.value && step?.options?.object?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* objectData */}
                    {step?.options?.objectData && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('objectdata')}{step?.options?.objectData?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="objectData"
                            size='small' 
                            placeholder={step?.options?.objectData?.placeholder}
                            value={step?.options?.objectData?.value}
                            error={!step?.options?.objectData?.value && step?.options?.objectData?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "objectData", step?.options?.objectData?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.objectData?.value && step?.options?.objectData?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* objectKey */}
                    {step?.options?.objectKey && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('objectkey')}{step?.options?.objectKey?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="objectKey"
                            size='small' 
                            placeholder={step?.options?.objectKey?.placeholder}
                            value={step?.options?.objectKey?.value}
                            error={!step?.options?.objectKey?.value && step?.options?.objectKey?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "objectKey", step?.options?.objectKey?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.objectKey?.value && step?.options?.objectKey?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* calendarID */}
                    {step?.options?.calendarID && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('calendarid')}{step?.options?.calendarID?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="calendarID"
                            size='small' 
                            placeholder={step?.options?.calendarID?.placeholder}
                            value={step?.options?.calendarID?.value}
                            error={!step?.options?.calendarID?.value && step?.options?.calendarID?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "calendarID", step?.options?.calendarID?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.calendarID?.value && step?.options?.calendarID?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* from */}
                    {step?.options?.from && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('from')}{step?.options?.from?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="from"
                            size='small' 
                            placeholder={step?.options?.from?.placeholder}
                            value={step?.options?.from?.value}
                            error={!step?.options?.from?.value && step?.options?.from?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "from", step?.options?.from?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.from?.value && step?.options?.from?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* to */}
                    {step?.options?.to && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('to')}{step?.options?.to?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="to"
                            size='small' 
                            placeholder={step?.options?.to?.placeholder}
                            value={step?.options?.to?.value}
                            error={!step?.options?.to?.value && step?.options?.to?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "to", step?.options?.to?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.to?.value && step?.options?.to?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* subject */}
                    {step?.options?.subject && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('subject')}{step?.options?.subject?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="subject"
                            size='small' 
                            placeholder={step?.options?.subject?.placeholder}
                            value={step?.options?.subject?.value}
                            error={!step?.options?.subject?.value && step?.options?.subject?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "subject", step?.options?.subject?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.subject?.value && step?.options?.subject?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* body */}
                    {step?.options?.body && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('body')}{step?.options?.body?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="body"
                            size='small'
                            multiline
                            rows={4}
                            placeholder={step?.options?.body?.placeholder}
                            value={step?.options?.body?.value}
                            error={!step?.options?.body?.value && step?.options?.body?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "body", step?.options?.body?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.body?.value && step?.options?.body?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* attachments */}
                    {step?.options?.attachments && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('attachments')}{step?.options?.attachments?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="attachments"
                            size='small' 
                            placeholder={step?.options?.attachments?.placeholder}
                            value={step?.options?.attachments?.value}
                            error={!step?.options?.attachments?.value && step?.options?.attachments?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "attachments", step?.options?.attachments?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.attachments?.value && step?.options?.attachments?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* cc */}
                    {step?.options?.cc && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('cc')}{step?.options?.cc?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="cc"
                            size='small' 
                            placeholder={step?.options?.cc?.placeholder}
                            value={step?.options?.cc?.value}
                            error={!step?.options?.cc?.value && step?.options?.cc?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "cc", step?.options?.cc?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.cc?.value && step?.options?.cc?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* bcc */}
                    {step?.options?.bcc && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('bcc')}{step?.options?.bcc?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="bcc"
                            size='small' 
                            placeholder={step?.options?.bcc?.placeholder}
                            value={step?.options?.bcc?.value}
                            error={!step?.options?.bcc?.value && step?.options?.bcc?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "bcc", step?.options?.bcc?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.bcc?.value && step?.options?.bcc?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* query */}
                    {step?.options?.query && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('query')}{step?.options?.query?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="query"
                            size='small' 
                            placeholder={step?.options?.query?.placeholder}
                            value={step?.options?.query?.value}
                            error={!step?.options?.query?.value && step?.options?.query?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "query", step?.options?.query?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.query?.value && step?.options?.query?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* summary */}
                    {step?.options?.summary && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('summary')}{step?.options?.summary?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="summary"
                            size='small' 
                            placeholder={step?.options?.summary?.placeholder}
                            value={step?.options?.summary?.value}
                            error={!step?.options?.summary?.value && step?.options?.summary?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "summary", step?.options?.summary?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.summary?.value && step?.options?.summary?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                     {/* descriptions */}
                     {step?.options?.descriptions && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('descriptions')}{step?.options?.descriptions?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="descriptions"
                            size='small' 
                            placeholder={step?.options?.descriptions?.placeholder}
                            value={step?.options?.descriptions?.value}
                            error={!step?.options?.descriptions?.value && step?.options?.descriptions?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "descriptions", step?.options?.descriptions?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.descriptions?.value && step?.options?.descriptions?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* limit */}
                    {step?.options?.limit && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('limit')}{step?.options?.limit?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="limit"
                            size='small' 
                            placeholder={step?.options?.limit?.placeholder}
                            value={step?.options?.limit?.value}
                            error={!step?.options?.limit?.value && step?.options?.limit?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "limit", step?.options?.limit?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.limit?.value && step?.options?.limit?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* gmailMessages */}
                    {step?.options?.gmailMessages && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('gmailmessages')}{step?.options?.gmailMessages?.required && <span>*</span>}</Typography>
                        <Autocomplete
                            name="gmailMessages"
                            size='small'
                            multiple={step?.options?.gmailMessages?.value ? true : false}
                            options={scriptsteps?.filter(item => item.name === 'getGmail')?.map(item => item.output.key)}
                            getOptionLabel={(option) => option || ""}
                            isOptionEqualToValue={(option, value) => option && value && option === value}
                            value={step?.options?.gmailMessages?.value ? [step?.options?.gmailMessages?.value] : null}onChange={(event, newValue) => {
                                handleOnChange({ target : { name: 'gmailMessages', value: (typeof newValue === "object") ? newValue[0] : newValue } });
                            }}
                            renderTags={() => 
                                <Box className='gmail' size='small' variant="filled" label={step?.options?.gmailMessages?.value} component={Chip}></Box>
                            }
                            renderInput={(params) => (
                                <Box sx={{ display: "flex", alignItems: "center" }}>
                                    <TextField
                                        {...params}
                                        error={!step?.options?.gmailMessages?.value && step?.options?.gmailMessages?.required && isError}
                                        placeholder={step?.options?.gmailMessages?.placeholder}
                                        sx={{
                                            "& .MuiAutocomplete-endAdornment": {
                                                paddingRight: "40px"
                                            }
                                        }}
                                    />
                                    <IconButton sx={{ position: "absolute", right: "15px" }} size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "gmailMessages", step?.options?.gmailMessages?.value)}><img src={FomulaFx} width={22}/></IconButton>
                                </Box>
                            )}
                        />
                        {!step?.options?.gmailMessages?.value && step?.options?.gmailMessages?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* eventID */}
                    {step?.options?.eventID && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('eventid')}{step?.options?.eventID?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="eventID"
                            size='small' 
                            placeholder={step?.options?.eventID?.placeholder}
                            value={step?.options?.eventID?.value}
                            error={!step?.options?.eventID?.value && step?.options?.eventID?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "eventID", step?.options?.eventID?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.eventID?.value && step?.options?.eventID?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* attendees */}
                    {step?.options?.attendees && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('attendees')}{step?.options?.attendees?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="attendees"
                            size='small' 
                            placeholder={step?.options?.attendees?.placeholder}
                            value={step?.options?.attendees?.value}
                            error={!step?.options?.attendees?.value && step?.options?.attendees?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "attendees", step?.options?.attendees?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.attendees?.value && step?.options?.attendees?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* fileID */}
                    {step?.options?.fileID && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('fileid')}{step?.options?.fileID?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="fileID"
                            size='small' 
                            placeholder={step?.options?.fileID?.placeholder}
                            value={step?.options?.fileID?.value}
                            error={!step?.options?.fileID?.value && step?.options?.fileID?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "fileID", step?.options?.fileID?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.fileID?.value && step?.options?.fileID?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* title */}
                    {step?.options?.title && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('title')}{step?.options?.title?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="title"
                            size='small' 
                            placeholder={step?.options?.title?.placeholder}
                            value={step?.options?.title?.value}
                            error={!step?.options?.title?.value && step?.options?.title?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "title", step?.options?.title?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.title?.value && step?.options?.title?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* extension */}
                    {step?.options?.extension && 
                    <FormControl  size="small" error={!step?.options?.extension?.value && step?.options?.extension?.required && isError}>
                        <Typography fontSize="inherit" component="label">{translate('extension')}{step?.options?.extension?.required && <span>*</span>}</Typography>
                        <Select
                            name="extension"
                            value={step?.options?.extension?.value}onChange={handleOnChange}
                        >
                            <MenuItem value="xlsx">xlsx</MenuItem>
                            <MenuItem value="pdf">pdf</MenuItem>
                            <MenuItem value="csv">csv</MenuItem>
                        </Select>
                        {!step?.options?.extension?.value && step?.options?.extension?.required && isError &&
                        <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* method */}
                    {step?.options?.method && 
                    <FormControl  size="small" error={!step?.options?.method?.value && step?.options?.method?.required && isError}>
                        <Typography fontSize="inherit" component="label">{translate('method')}{step?.options?.method?.required && <span>*</span>}</Typography>
                        <Select
                            name="method"
                            value={step?.options?.method?.value}onChange={handleOnChange}
                        >
                            <MenuItem value="GET">GET</MenuItem>
                            <MenuItem value="POST">POST</MenuItem>
                            <MenuItem value="PUT">PUT</MenuItem>
                            <MenuItem value="PATCH">PATCH</MenuItem>
                            <MenuItem value="DELETE">DELETE</MenuItem>
                        </Select>
                        {!step?.options?.method?.value && step?.options?.method?.required && isError &&
                        <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* httpHeaders */}
                    {step?.options?.httpHeaders && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('httpheaders')}{step?.options?.httpHeaders?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="httpHeaders"
                            size='small' 
                            placeholder={step?.options?.httpHeaders?.placeholder}
                            value={step?.options?.httpHeaders?.value}
                            error={!step?.options?.httpHeaders?.value && step?.options?.httpHeaders?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "httpHeaders", step?.options?.httpHeaders?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.httpHeaders?.value && step?.options?.httpHeaders?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* params */}
                    {step?.options?.params && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('params')}{step?.options?.params?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="params"
                            size='small' 
                            placeholder={step?.options?.params?.placeholder}
                            value={step?.options?.params?.value}
                            error={!step?.options?.params?.value && step?.options?.params?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "params", step?.options?.params?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.params?.value && step?.options?.params?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* documentID */}
                    {step?.options?.documentID && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('documentid')}{step?.options?.documentID?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="documentID"
                            size='small' 
                            placeholder={step?.options?.documentID?.placeholder}
                            value={step?.options?.documentID?.value}
                            error={!step?.options?.documentID?.value && step?.options?.documentID?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "documentID", step?.options?.documentID?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.documentID?.value && step?.options?.documentID?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* index */}
                    {step?.options?.index && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('index')}{step?.options?.index?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="index"
                            size='small' 
                            placeholder={step?.options?.index?.placeholder}
                            value={step?.options?.index?.value}
                            error={!step?.options?.index?.value && step?.options?.index?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "index", step?.options?.index?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.index?.value && step?.options?.index?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* position */}
                    {step?.options?.position && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('position')}{step?.options?.position?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="position"
                            size='small' 
                            placeholder={step?.options?.position?.placeholder}
                            value={step?.options?.position?.value}
                            error={!step?.options?.position?.value && step?.options?.position?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "position", step?.options?.position?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.position?.value && step?.options?.position?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* delimiter */}
                    {step?.options?.delimiter && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('delimiter')}{step?.options?.delimiter?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="delimiter"
                            size='small' 
                            placeholder={step?.options?.delimiter?.placeholder}
                            value={step?.options?.delimiter?.value}
                            error={!step?.options?.delimiter?.value && step?.options?.delimiter?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "delimiter", step?.options?.delimiter?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.delimiter?.value && step?.options?.delimiter?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* clip */}
                    {step?.options?.clip && 
                    <FormControl>
                        <Typography fontSize="inherit" component="label">{translate('clip')}{step?.options?.clip?.required && <span>*</span>}</Typography>
                        <OutlinedInput
                            type='search'
                            name="clip"
                            size='small' 
                            placeholder={step?.options?.clip?.placeholder}
                            value={step?.options?.clip?.value}
                            error={!step?.options?.clip?.value && step?.options?.clip?.required && isError}
                            endAdornment={<IconButton size='small' color='primary' onClick={() =>  handleOpenCalculation(index, step, "clip", step?.options?.clip?.value)}><img src={FomulaFx} width={22}/></IconButton>}
                            onChange={handleOnChange}
                        />
                        {!step?.options?.clip?.value && step?.options?.clip?.required && isError &&
                         <FormHelperText sx={{ color: "error.main" }}>{translate('thisfieldisrequired')}</FormHelperText>
                        }
                    </FormControl>}
                    {/* * * * * * * * * * * * * * * * * * * * * * * * * *
                    * * * * * * * * * * * * * * * * * * * * * * * * *
                    * * * * * * * * * * * * * * * * * * * * * * * * *
                    * * * * * * * * * * * * * * * * * * * * * * * * *
                    * * * * * * * * * * * * * * * * * * * * * * * * * */}
                    {/* encoding */}
                    {step?.options?.encoding &&  
                    <FormGroup sx={{ ml: 1 }}>
                           <FormLabel>{translate('encoding')}</FormLabel>
                           <RadioGroup
                                row
                                name="encoding"
                                value={step?.options?.encoding?.value}
                                onChange={handleOnChange}
                            >
                                <FormControlLabel value="UTF-8" control={<Radio />} label="UTF-8" />
                                <FormControlLabel value="Shift_JIS" control={<Radio />} label="Shift_JIS" />
                                <FormControlLabel value="Latin1" control={<Radio />} label="Latin1" />
                            </RadioGroup>
                    </FormGroup>}
                    {/* waitForNavigation */}
                    {step?.options?.waitForNavigation &&  
                    <FormGroup sx={{ ml: 1 }}>
                        <FormControlLabel 
                            control={
                                <Switch  
                                    name="waitForNavigation"
                                    size="small" 
                                    checked={step?.options?.waitForNavigation?.value} 
                                    onChange={handleOnSwitch}
                                />
                            }
                            label={translate('waitfornavigation')}
                        />
                    </FormGroup>}
                    {/* acceptDialog */}
                    {step?.options?.acceptDialog &&  
                    <FormGroup sx={{ ml: 1 }}>
                        <FormControlLabel 
                            control={
                                <Switch  
                                    name="acceptDialog"
                                    size="small" 
                                    checked={step?.options?.acceptDialog?.value} 
                                    onChange={handleOnSwitch}
                                />
                            }
                            label={translate('acceptdialog')}
                        />
                    </FormGroup>}
                    {/* clearValue */}
                    {step?.options?.clearValue &&  
                    <FormGroup sx={{ ml: 1 }}>
                        <FormControlLabel 
                            control={
                                <Switch  
                                    name="clearValue"
                                    size="small" 
                                    checked={step?.options?.clearValue?.value} 
                                    onChange={handleOnSwitch}
                                />
                            }
                            label={translate('clearvalue')}
                        />
                    </FormGroup>}
                    {/* screenshot */}
                    {step?.options?.screenshot &&  
                    <FormGroup sx={{ ml: 1 }}>
                        <FormControlLabel 
                            control={
                                <Switch  
                                    name="screenshot"
                                    size="small" 
                                    checked={step?.options?.screenshot?.value} 
                                    onChange={handleOnSwitch}
                                />
                            }
                            label={translate('screenshot')}
                        />
                    </FormGroup>}
                    {/* textOnly */}
                    {step?.options?.textOnly &&  
                    <FormGroup sx={{ ml: 1 }}>
                        <FormControlLabel 
                            control={
                                <Switch  
                                    name="textOnly"
                                    size="small" 
                                    checked={step?.options?.textOnly?.value} 
                                    onChange={handleOnSwitch}
                                />
                            }
                            label={translate('textonly')}
                        />
                    </FormGroup>}
                    {/* ignoreError */}
                    {step?.options?.ignoreError &&  
                    <FormGroup sx={{ ml: 1 }}>
                        <FormControlLabel 
                            control={
                                <Switch  
                                    name="ignoreError"
                                    size="small" 
                                    checked={step?.options?.ignoreError?.value} 
                                    onChange={handleOnSwitch}
                                />
                            }
                            label={translate('ignoreerror')}
                        />
                    </FormGroup>}
                    {/* downloadFile */}
                    {step?.options?.downloadFile &&  
                    <FormGroup sx={{ ml: 1 }}>
                        <FormControlLabel 
                            control={
                                <Switch  
                                    name="downloadFile"
                                    size="small" 
                                    checked={step?.options?.downloadFile?.value} 
                                    onChange={handleOnSwitch}
                                />
                            }
                            label={translate('downloadfile')}
                        />
                    </FormGroup>}
                    {/* fullPath */}
                    {step?.options?.fullPath &&  
                    <FormGroup sx={{ ml: 1 }}>
                        <FormControlLabel 
                            control={
                                <Switch  
                                    name="fullPath"
                                    size="small" 
                                    checked={step?.options?.fullPath?.value} 
                                    onChange={handleOnSwitch}
                                />
                            }
                            label={translate('fullpath')}
                        />
                    </FormGroup>}
                    {/* bom */}
                    {step?.options?.bom &&  
                    <FormGroup sx={{ ml: 1 }}>
                        <FormControlLabel 
                            control={
                                <Switch  
                                    name="bom"
                                    size="small" 
                                    checked={step?.options?.bom?.value} 
                                    onChange={handleOnSwitch}
                                />
                            }
                            label={translate('bom')}
                        />
                    </FormGroup>}
                    {/* headers */}
                    {step?.options?.headers &&  
                    <FormGroup sx={{ ml: 1 }}>
                        <FormControlLabel 
                            control={
                                <Switch  
                                    name="headers"
                                    size="small" 
                                    checked={step?.options?.headers?.value} 
                                    onChange={handleOnSwitch}
                                />
                            }
                            label={translate('headers')}
                        />
                    </FormGroup>}
                    {/* markAsRead */}
                    {step?.options?.markAsRead &&  
                    <FormGroup sx={{ ml: 1 }}>
                        <FormControlLabel 
                            control={
                                <Switch  
                                    name="markAsRead"
                                    size="small" 
                                    checked={step?.options?.markAsRead?.value} 
                                    onChange={handleOnSwitch}
                                />
                            }
                            label={translate('markasread')}
                        />
                    </FormGroup>}
                </Box>
                <Box className='handle step-options-bottom' sx={{ display: "flex", justifyContent: "right", gap: 1, p: 2 }}>
                    <Button variant="contained" size="small" disableElevation color='secondary' onClick={handleClose}>
                    {translate('cancel')}
                    </Button>
                    <Button variant="contained" size="small" disableElevation color="info" onClick={handleClickAgree}>
                    {translate('save')}
                    </Button>
                </Box>
                <Dialog
                    open={selectorPicker.open}
                    onClose={() => setSelectorPicker({ open: false, loading: false, data: null, error: "" })}
                    maxWidth="lg"
                    fullWidth
                >
                    <DialogTitle>対象を選択</DialogTitle>
                    <DialogContent>
                        {selectorPicker.loading &&
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 260 }}>
                                <CircularProgress />
                            </Box>
                        }
                        {selectorPicker.error &&
                            <Typography color="error" sx={{ p: 2 }}>{selectorPicker.error}</Typography>
                        }
                        {selectorPicker.data &&
                            <Box sx={{ width: '100%', overflow: 'auto', border: '1px solid #d8e0ea' }}>
                                <Box sx={{ position: 'relative', width: selectorPicker.data.width, height: selectorPicker.data.height }}>
                                    <img
                                        src={`data:image/png;base64,${selectorPicker.data.screenshotBase64}`}
                                        width={selectorPicker.data.width}
                                        height={selectorPicker.data.height}
                                        alt=""
                                        style={{ display: 'block' }}
                                    />
                                    {selectorPicker.data.elements?.map((element, elementIndex) => (
                                        <Tooltip key={`${element.selector}-${elementIndex}`} title={`${element.tag}${element.text ? `: ${element.text}` : ''}`}>
                                            <Box
                                                onClick={() => handleSelectElement(element)}
                                                sx={{
                                                    position: 'absolute',
                                                    left: element.x,
                                                    top: element.y,
                                                    width: element.width,
                                                    height: element.height,
                                                    border: '2px solid #20c7b8',
                                                    background: 'rgba(32,199,184,0.10)',
                                                    cursor: 'crosshair',
                                                    '&:hover': {
                                                        borderColor: '#ff7a00',
                                                        background: 'rgba(255,122,0,0.18)'
                                                    }
                                                }}
                                            />
                                        </Tooltip>
                                    ))}
                                </Box>
                            </Box>
                        }
                    </DialogContent>
                </Dialog>
            </Box>}
        </Draggable>
  );
}
export default withTranslate(StepOptions);
